import React from 'react'
import { MotionConfig } from 'framer-motion'
import { LanguageProvider } from './context/LanguageContext'
import Layout from './components/common/Layout'

// Used by both gatsby-browser.js and gatsby-ssr.js, so the server renders the same tree
// the browser hydrates. The page's language comes from its context (see gatsby-node.js).
// Visitors who ask their system for reduced motion get fades without the sliding.
export const wrapPageElement = ({ element, props }) => (
  <MotionConfig reducedMotion="user">
    <LanguageProvider lang={props.pageContext.lang}>
      <Layout theme={props.pageContext.theme} alternates={props.pageContext.alternates}>
        {element}
      </Layout>
    </LanguageProvider>
  </MotionConfig>
)
